<template>
  <div :style="{'top': top+'%', 'left': left+'%', 'animation-delay': delay+'ms'}" class="estrella"></div>
</template>

<script>
export default {
  name: 'Estrella',
  data: function(){
      return {
        top: 0,
        left: 0,
        delay: 0
      }
  },
  mounted(){
    this.top = Math.floor(Math.random() * 50) + 1;
    this.left = Math.floor(Math.random() * 100) + 1;
    this.delay = Math.floor(Math.random() * 1000) + 1;
  }
}
</script>

<style lang="scss">
  .estrella{
    position: absolute;
    width: 2px;
    height: 2px;
    background-color: white;
    border-radius: 50%;
    will-change: box-shadow;
    animation: blink 2000ms linear infinite;
  }

  @keyframes blink{
    0%{ box-shadow: 0px 0px 0px #ffffe3; }
    5%{ box-shadow: 0px 0px 1px 1px #ffffe3; }
    30%{ box-shadow: 0px 0px 0px #ffffe3; }
    40%{ box-shadow: 0px 0px 1px 1px #ffffe3; }
    42%{ box-shadow: 0px 0px 2px 2px #ffffe3; }
    45%{ box-shadow: 0px 0px 1px 1px #ffffe3; }
    65%{ box-shadow: 0px 0px 0px #ffffe3; }
    75%{ box-shadow: 0px 0px 1px 1px #ffffe3; }
    90%{ box-shadow: 0px 0px 0px #ffffe3; }
    95%{ box-shadow: 0px 0px 1px 1px #ffffe3; }
    100%{ box-shadow: 0px 0px 0px 0px #ffffe3; }
  }
</style>
